import { 
    LookBackToggleOptionsPanel, 
    LookBackCheckboxInfo
} from 'Widgets/Scripts/LookBackToggleOptionsPanel';
import VSS_Diag = require("VSS/Diag");
import { BurndownSettings } from 'Widgets/Scripts/Burndown/BurndownSettings';
import { BurnDirection } from 'Widgets/Scripts/Burndown/BurnDirection';
import * as WidgetResources from 'Widgets/Scripts/Resources/TFS.Resources.Widgets';
import FeatureAvailability_Services = require("VSS/FeatureAvailability/Services");

/**Describes values of panel. This contract is used for initialization and exposing state. */
export interface BurndownToggleOptionsPanelValues {
    isBurndownTrendlineEnabled: boolean;
    isScopeTrendlineEnabled: boolean;
    isCompletedWorkEnabled?: boolean;
    IsStackByWorkItemTypeEnabled: boolean;
    isShowResolvedItemsAsCompletedEnabled?: boolean;
}

export interface BurndownToggleOptionsPanelOptions {
    onChange: () => void;
    settings: BurndownSettings;
    burnDirection: BurnDirection;
}

export class BurndownToggleOptionsPanel extends LookBackToggleOptionsPanel {

    private static readonly burndownTrendlineCheckboxId = 'burndown-trendline-checkbox';
    private static readonly scopeTrendlineCheckboxId = 'scope-trendline-checkbox';
    private static readonly completedWorkTrendlineCheckboxId = 'completed-work-checkbox';
    private static readonly stackByWITCheckboxId = 'stack-by-workitemtype-checkbox';
    private static readonly showResolvedItemsAsCompletedId = 'show-resolved-as-completed-checkbox';

    // feature flag
    private static readonly showResolvedItemsAsCompletedFeatureFlag = "WebAccess.Widgets.ShowResolvedItemsAsCompleted";
    
    constructor(options: BurndownToggleOptionsPanelOptions) {
        super({
            onChange: options.onChange,
            checkboxInfo: BurndownToggleOptionsPanel.getCheckboxInfoList(options)
        });
    }

    private static getCheckboxInfoList(options: BurndownToggleOptionsPanelOptions): LookBackCheckboxInfo[] {
        let checkboxInfoList: LookBackCheckboxInfo[];
        checkboxInfoList = [
            {
                checkboxId: BurndownToggleOptionsPanel.burndownTrendlineCheckboxId,
                label:
                    options.burnDirection === BurnDirection.Down
                        ? WidgetResources.BurndownWidget_AdvancedFeaturesBurndownTrendlineLabel
                        : WidgetResources.BurnupWidget_AdvancedFeaturesBurnupTrendlineLabel,
                checked: options.settings.burndownTrendlineEnabled,
                enabled: true
            },
            {
                checkboxId: BurndownToggleOptionsPanel.scopeTrendlineCheckboxId,
                label: WidgetResources.BurndownWidget_AdvancedFeaturesScopeTrendlineLabel,
                checked: options.settings.totalScopeTrendlineEnabled,
                enabled: true
            },
            {
                checkboxId: BurndownToggleOptionsPanel.completedWorkTrendlineCheckboxId,
                label:
                    options.burnDirection === BurnDirection.Down
                        ? WidgetResources.BurndownWidget_AdvancedFeaturesCompletedWorkLabel
                        : WidgetResources.BurnupWidget_AdvancedFeaturesRemainingWorkLabel,
                checked: options.settings.completedWorkEnabled,
                enabled: true
            },
            {
                checkboxId: BurndownToggleOptionsPanel.stackByWITCheckboxId,
                label:  options.burnDirection === BurnDirection.Down ? WidgetResources.BurndownWidget_StackByLabel : WidgetResources.BurnupWidget_StackByLabel,
                checked: options.settings.stackByWorkItemTypeEnabled,
                enabled: true
            }
        ];

        if (FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(BurndownToggleOptionsPanel.showResolvedItemsAsCompletedFeatureFlag, false)) {
            checkboxInfoList.push({
                checkboxId: BurndownToggleOptionsPanel.showResolvedItemsAsCompletedId,
                label:  WidgetResources.ShowResolvedItemsAsCompletedLabel,
                checked: options.settings.showResolvedItemsAsCompletedEnabled,
                enabled: true,
                toolTipText: WidgetResources.ShowResolvedItemsAsCompletedToolTipText
            })
        }
        return checkboxInfoList;
    }

    public getSettings(): BurndownToggleOptionsPanelValues {
        let burndownTrendlineSettings: boolean;
        let scopeTrendlineSettings: boolean;
        let completeWorkSettings: boolean;
        let stackByWorkItemTypeSettings: boolean;
        let showResolvedItemsAsCompletedSettings: boolean;

        for (let i in this._options.checkboxInfo) {
            switch (this._options.checkboxInfo[i].checkboxId) {
                case BurndownToggleOptionsPanel.burndownTrendlineCheckboxId: {
                    burndownTrendlineSettings = this.checkboxes[i].getSettings();
                    break;
                }
                case BurndownToggleOptionsPanel.scopeTrendlineCheckboxId: {
                    scopeTrendlineSettings = this.checkboxes[i].getSettings();
                    break;
                }
                case BurndownToggleOptionsPanel.completedWorkTrendlineCheckboxId: {
                    completeWorkSettings = this.checkboxes[i].getSettings();
                    break;
                }
                case BurndownToggleOptionsPanel.stackByWITCheckboxId: {
                    stackByWorkItemTypeSettings = this.checkboxes[i].getSettings();
                    break;
                }
                case BurndownToggleOptionsPanel.showResolvedItemsAsCompletedId:{
                    showResolvedItemsAsCompletedSettings = this.checkboxes[i].getSettings();
                    break;
                }
                default: {
                    VSS_Diag.logError("Could not identify checkboxId " + this._options.checkboxInfo[i].checkboxId + ": BurndownToggleOptionsPanel");
                    break;
                }
            }
        }
        
        // if feature is disabled, always reset value to false
        if(!FeatureAvailability_Services.FeatureAvailabilityService.isFeatureEnabled(BurndownToggleOptionsPanel.showResolvedItemsAsCompletedFeatureFlag, false)){
            showResolvedItemsAsCompletedSettings = false;
        }

        return {
            isBurndownTrendlineEnabled: burndownTrendlineSettings,
            isScopeTrendlineEnabled:  scopeTrendlineSettings,
            isCompletedWorkEnabled:  completeWorkSettings,
            IsStackByWorkItemTypeEnabled:  stackByWorkItemTypeSettings,
            isShowResolvedItemsAsCompletedEnabled: showResolvedItemsAsCompletedSettings
        };
    }
}